/**
 * userInfo
 * 用户信息
 */

export default {
  namespaced: true,
  state: {
    //用户邮箱
    userEmail: "",
    userPayFormInfo: {
      status: false,
    },
  },
  mutations: {
    set_userEmail(state, val) {
      state.userEmail = val;
    },
    set_userPayFormInfo(state, val) {
      state.userPayFormInfo = val;
    },
  },
};
